export async function MountForm(props: any, el: Element) {
	const a = await import('./Components/StandardForm');
	a.MountForm(props, el);
}

(window as any).MountForm = MountForm;
